import type { ContactDraft, ContactModalState } from '../../../types/InfrastructureManagerTypes';

export const CONTACT_FIELDS = ['name', 'company', 'phone', 'email', 'role', 'notes'] as const;

export const REQUIRED_FIELDS: ReadonlySet<keyof ContactDraft> = new Set(['name', 'phone', 'email']);

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const PHONE_DIGITS = 10;

export const NON_DIGITS = /\D/g;

export const SEARCH_DEBOUNCE_MS = 300;

export const EMPTY_CONTACT_DRAFT: ContactDraft = { name: '', email: '', phone: '', company: '', role: '', notes: '' };

export const CLOSED_CONTACT_MODAL: ContactModalState = { isOpen: false, groupId: null, contact: null };

export const CLOSED_GROUP_CREATION = { isOpen: false, name: '' };

export const CONTACT_VALIDATION_MESSAGES = {
  NAME_REQUIRED: 'Name is required.',
  EMAIL_REQUIRED: 'Email is required.',
  EMAIL_INVALID: 'Enter a valid email address.',
  PHONE_REQUIRED: 'Phone number is required.',
  PHONE_LENGTH: `Phone number must be exactly ${PHONE_DIGITS} digits.`,
};
